import i18n from 'i18next';
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/es-us';
import 'moment/locale/fr-ca';
import 'moment/locale/ja';
import 'moment/locale/pt-br';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//
import deLocales from '@locales/de.json';
import enLocales from '@locales/en.json';
import esLocales from '@locales/es.json';
import frLocales from '@locales/fr.json';
import jaLocales from '@locales/ja.json';
import ptBRLocales from '@locales/pt-BR.json';
import zhCNLocales from '@locales/zh-CN.json';
import zhTWLocales from '@locales/zh-TW.json';
import { createBrandNamePostProcessor } from 'careit';
import { getRuntimeBrandName } from 'src/utils/brand';
import { detectLanguage, FALLBACK_LANG } from './detectLanguage';

// ----------------------------------------------------------------------

const brandNamePostProcessor =
  createBrandNamePostProcessor(getRuntimeBrandName);

i18n
  .use(LanguageDetector)
  .use(brandNamePostProcessor)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': { translation: enLocales },
      'es-US': { translation: esLocales },
      'fr-CA': { translation: frLocales },
      'zh-CN': { translation: zhCNLocales },
      'zh-TW': { translation: zhTWLocales },
      'de-DE': { translation: deLocales },
      'ja-JP': { translation: jaLocales },
      'pt-BR': { translation: ptBRLocales },
    },
    lng: detectLanguage({
      stored: localStorage.getItem('i18nextLng'),
      browserLanguages: navigator.languages ?? [navigator.language],
    }),
    fallbackLng: FALLBACK_LANG,
    debug: false,
    // Must match the bundle registered above (`translation`), otherwise a bare
    // `useTranslation()` resolves nothing and `t()` echoes the raw key back.
    ns: ['translation'],
    defaultNS: 'translation',
    postProcess: ['brandName'],
    interpolation: {
      escapeValue: false,
    },
  });

// Importing a moment locale also makes it moment's global locale, so set it
// from the UI language here and follow language changes from then on.
// moment resolves e.g. 'es-US' to es-us, 'pt-BR' to pt-br and 'de-DE' to de.
moment.locale(i18n.language);
i18n.on('languageChanged', (lng) => moment.locale(lng));

export default i18n;
